import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLinkedin,
  faStaylinked,
  faGoogle,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";

import "./ShareVlog.css";

const ShareVlog = ({ vlogId }) => {
  const baseUrl =
    process.env.NODE_ENV === "production"
      ? "https://www.pinati.co/#"
      : "http://localhost:3000/#";
  const vlogUrl = `${baseUrl}${vlogId}`;
  const linkedinShareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
    vlogUrl
  )}&title=Check%20out%20this%20vlog&summary=Here's%20why%20you%20should%20watch%20this%20vlog&source=YourWebsiteName`;
  const gmailShareUrl = `https://mail.google.com/mail/u/0/?view=cm&fs=1&to=&su=Check%20out%20this%20vlog&body=Here's%20a%20cool%20vlog%20I%20found%20that%20I%20thought%20you%20might%20like:%20${encodeURIComponent(
    vlogUrl
  )}&tf=1`;
  const whatsappShareUrl = `https://wa.me/?text=${encodeURIComponent(
    "Here's a cool vlog I found that I thought you might like: " + vlogUrl
  )}`;

  const [copySuccess, setCopySuccess] = useState();

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(vlogUrl)
      .then(() => {
        setCopySuccess("Copied");
        setTimeout(() => setCopySuccess(null), 1500);
      })
      .catch(() => {
        setCopySuccess("Failed");
        setTimeout(() => setCopySuccess(null), 1500);
      });
  };

  return (
    <>
      <div className="align-items-center border-5 share-border-top mt-5 mx-auto text-center w-50">
        <h3 className="mt-3 n-color-purple">אשמח שתשתפו את הוולוגים שלי</h3>
        <div className="mx-auto share-links w-50">
          <div className="link-item">
            <a
              href={whatsappShareUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="icon-square bg-whatsapp">
                <FontAwesomeIcon icon={faWhatsapp} />
              </div>
              <span className="tooltip">WhatsApp</span>
            </a>
          </div>
          <div className="link-item">
            <a
              href={linkedinShareUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="icon-square bg-linkedIn">
                <FontAwesomeIcon icon={faLinkedin} />
              </div>
              <span className="tooltip">LinkedIn</span>
            </a>
          </div>
          <div className="link-item">
            <div onClick={copyToClipboard}>
              <div className="icon-square bg-link">
                <FontAwesomeIcon icon={faStaylinked} />
              </div>
              <span className="tooltip">Link</span>
              {copySuccess && (
                <span className="copySuccess">{copySuccess}</span>
              )}
            </div>
          </div>
          <div className="link-item">
            <a href={gmailShareUrl} target="_blank" rel="noopener noreferrer">
              <div className="icon-square bg-gmail">
                <FontAwesomeIcon icon={faGoogle} />
              </div>
              <span className="tooltip">Gmail</span>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShareVlog;
